import React from 'react'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { useSelector } from 'react-redux'

const WarningDialog = () => {
  const state = useSelector(({ warningDialog }) => warningDialog)

  return (
    <SubmitDialog
      open={state.open}
      title={state.title}
      description={state.description}
      submitText={state.submitText}
      onSubmit={state.onSubmit}
      closeText={state.closeText}
      onClose={state.onClose}
      type={state.type}
    />
  )
}

export default WarningDialog
